import { Attribute, Convention } from '../../../concepts/objects';
import { Physical } from '../../canvas/entities/Physical';
import { HandwritingMode } from '../../preferences/PreferencesModel';

export interface Handwritten extends Physical {
    userId: string;
}

export type HandwritingMappings = Record<string, string>;

export const Handwritten = new Convention<Handwritten>('Handwritten');
export const HandwritingMappingsAttr = new Attribute<HandwritingMappings, Handwritten>('HandwritingMappings', {});
export const HandwritingModeAttr = new Attribute<HandwritingMode, Handwritten>('handwritingMode', 'individual');

export const Handwriting = Object.freeze({
    resolve(handwritten: Handwritten) {

        const mode = HandwritingModeAttr.get(handwritten);
        const mappings = HandwritingMappingsAttr.get(handwritten);
        const { userId } = handwritten;

        if (mode === 'off') {
            return 'Inter';
        }

        if (mode !== 'uniform' && mappings?.[userId]) {
            return mappings[userId];
        }

        return 'Dekko';

    }
});
